class ItinerarioFormativo {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.dataInicioVigencia = dados ? dados.dataInicioVigencia : null;
    this.dataFinalVigencia = dados ? dados.dataFinalVigencia : null;
    this.nome = dados ? dados.nome : null;
    this.sigla = dados ? dados.sigla : null;
    this.ativo = dados ? dados.ativo : null;
    this.idCurso = dados ? dados.idCurso : null;
  }

  static validations(required, maxLength, numeric, decimal, dataFimMenor) {
    return {
      nome: { required, maxLength: maxLength(100) },
      sigla: { required, maxLength: maxLength(20) },
      dataInicioVigencia: { required },
      dataFinalVigencia: { dataFimMenor: dataFimMenor("dataInicioVigencia") },
      idCurso: { required }
    };
  }

  static validationMessages() {
    return {
      nome: {
        required: "Nome é obrigatório",
        maxLength: "Nome só aceita no máximo 100 caracteres"
      },
      sigla: {
        required: "Sigla é obrigatória",
        maxLength: "Sigla só aceita no máximo 200 caracteres"
      },
      dataInicioVigencia: {
        required: "Data Inicio Vigência é obrigatório"
      },
      dataFinalVigencia: {
        dataFimMenor:
          "Data Final de Vigência não pode ser menor que a Data Início de Vigência"
      },
      idCurso: {
        required: "Curso é obrigatório"
      }
    };
  }
}
export default ItinerarioFormativo;
